export default __webpack_public_path__ + "media/images/images_v2/ongletwhite-left2-15304284709992557b2e456a18b080fa.png";